import { format } from 'date-fns'
import { ko } from 'date-fns/locale'

type TParseAcquiredDateFn = (date?: number | null) => string | undefined

/**
 * 타임스탬프 값을 받아 MM/dd 오전 09시 형태로 반환합니다.
 * @param date
 * @returns
 */
export const formatToCustomDate = (date: number): string => {
  const dateToString = format(new Date(date), 'MM/dd a hh시')
  return dateToString.replace('AM', '오전').replace('PM', '오후')
}

/**
 * 타임스탬프 값을 받아 MM월dd일 오전 09시 형태로 반환합니다.
 * @param date
 * @returns
 */
export const formatKorDate = (date: number): string => {
  const dateToString = format(new Date(date), 'MM월dd일 a hh시')
  return dateToString.replace('AM', '오전').replace('PM', '오후')
}

/**
 * 서버에서 숫자로 되어있는 phoneNumber를 받아 000-0000-0000 형태로 반환합니다.
 * @param phoneNumber
 * @returns
 */
export const formatPhoneNumber = (phoneNumber?: string | null): string => {
  if (!phoneNumber) return ''
  if (phoneNumber.length === 11) {
    return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
  } else if (phoneNumber.length === 10) {
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
  } else {
    return phoneNumber
  }
}

/**
 * 전화번호에서 하이픈(-)을 제거하고 숫자만 반환합니다.
 * @param phoneNumber
 */
export const removeHyphensFromPhoneNumber = (phoneNumber: string): string => {
  return phoneNumber.replace(/-/g, '')
}

// 요일을 한글로 변환하는 함수
const getKoreanDay = (date: Date): string => {
  const dayNames = ['일', '월', '화', '수', '목', '금', '토']
  return dayNames[date.getDay()]
}

// 타임스탬프를 "MM월 DD일(요일)) HH시" 형식으로 변환하는 함수
export const formatStep2Timestamp = (timestamp: number): string => {
  const date = new Date(timestamp)
  const formattedDate = format(date, 'MM월 dd일', { locale: ko })
  const day = getKoreanDay(date)
  const formattedTime = format(date, 'HH시', { locale: ko })

  return `${formattedDate}(${day}) ${formattedTime}`
}

// 타임스탬프를 "MM/DD (요일) H시" 형식으로 변환하는 함수
export const formatStep3Timestamp = (timestamp: number): string => {
  const date = new Date(timestamp)
  const formattedDate = format(date, 'MM/dd', { locale: ko })
  const day = getKoreanDay(date)
  const formattedTime = format(date, 'H시', { locale: ko })

  return `${formattedDate} (${day}) ${formattedTime}`
}

/**
 * @desc 타임스태프 형식 날짜를 YYYY.MM.DD 형식으로 변환하여 반환합니다
 * @param date
 */
export const parseAcquiredDate: TParseAcquiredDateFn = (date) => {
  return date ? format(date, 'yyyy.MM.dd') : undefined
}
